import { showError } from '@redux/actions';
import { store } from '@redux/store';
import { allowImgExt } from '@utils/constants/enums';
import { MAX_FILE_SIZE } from '@utils/constants/value';

export * from './date';
export * from './validate';

export const convertToOptions = (dict: Dict): Option[] =>
  Object.entries(dict).map(([value, label]) => ({
    value,
    label,
  }));

export const generateKey = () => {
  return crypto.randomUUID();
};

export const generateImage = (path: string) => {
  const url = `${process.env.REACT_APP_IMAGE_URL}/${path}`;
  return url;
};

export const capitalizeFirstLetter = (val: string) => {
  return val.charAt(0).toUpperCase() + val.slice(1);
};

export const convertToSnakeCase = (input: string) => {
  return input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
};

export const validateFileImage = (file: File) => {
  if (file) {
    const fileExtension = file.name.split('.').pop()?.toLowerCase() ?? '';
    if (file.size > MAX_FILE_SIZE) {
      store.dispatch(showError({ message: 'MSE00025' }));
      return false;
    } else if (!allowImgExt.includes(fileExtension)) {
      store.dispatch(showError({ message: 'MSE00026' }));
      return false;
    }
    return true;
  }
};
